import { Box, Grid, Typography } from "@mui/material";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useRef } from "react";
import "react-image-gallery/styles/css/image-gallery.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { primary } from "../../constants/theme";
import { imagesWEBP } from "../../constants/webpImages";
import { Context } from "../../context/context";
import { sendAnalytics } from "../../utils/analyticsCommon";

import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import ConnectWithUs from "../../../src/modules/Brand/Form/connectWithUs";
import styles from "./WhyTurno.module.css";
import Image from "next/image";
import { BrandMiniVehicleData } from "../../../src/constants/brandMiniVehicleData";
import VehicleMiniCard from "../../../src/modules/Brand/vehicleMiniCard";

const images = [
  {
    original: imagesWEBP?.marketingr1,
  },
  {
    original: imagesWEBP?.marketingr2,
  },
  {
    original: imagesWEBP?.marketingr3,
  },
];

const WhyTurno = ({
  CARGO_EV_TURO_TABLE_DATA = [],
  CNG_CARGO_TABLE_DATA = [],
  DISCOVER_RANGE_HEADER = "",
  DISCOVER_RANGE_SUBHEADER = "",
  DISCOVER_RANGE_LIST = [],
  REVIEW_CARDS_CONTENT = [],
  TABLE_MAIN_HEADER_CONTENT = "",
  TABLE_SUB_HEADER_CONTENT = "",
  WHY_TURNO_HEADER = "",
  WHY_TURNO_SUB_TEXT = "",
  WHY_TURNO_DATA = [],
  TABLE_MAIN_SUB_HEADER_CONTENT = "",
  isHindi = false,
  CONNECT_WITH_US_HEADER = "",
  CONNECT_WITH_US_CTA_INGO = "",
  REVIEW_CARDS_HEADER = "",
  CHOOSE_ELECTRIC_AUTO_HEADER = [],
  isPassenger = false,
  showNewVehicles = false,
}) => {
  const { showLoanPopup, showConnectDrawer } = useContext(Context);
  const navigate = useRouter();

  const targetRef = useRef(null);

  const renderCommercialElectricTempoTable = () => {
    return (
      <>
        {renderImageIcon(
          imagesWEBP.linkStickerImageIcom,
          "link_icon_image",
          105,
          105
        )}
        <div className={styles?.TempoTableMainContainer}>
          <div className={styles?.TempoTableHeader}>
            <span>{TABLE_MAIN_HEADER_CONTENT}</span>
            <br />
            <span>{TABLE_MAIN_SUB_HEADER_CONTENT}</span>
          </div>
          <div className={styles?.TempoTableContainer}>
            <table className={styles.table} border={"1px solid black"}>
              <thead>
                <tr>
                  {TABLE_SUB_HEADER_CONTENT?.map(
                    ({ title = "", image_url = "" }, index) => (
                      <th key={index} className={styles.tableHeader}>
                        <span>{title}</span>
                        <br />
                        <Image
                          src={image_url}
                          alt={title}
                          width={70}
                          height={70}
                        />
                      </th>
                    )
                  )}
                </tr>
              </thead>
              {CARGO_EV_TURO_TABLE_DATA?.map((name, index) => (
                <tr key={`${name}-${index}`}>
                  <td className={styles.tableData}> &#9989; {name}</td>
                  <td className={styles.tableData}>
                    &#10060; {CNG_CARGO_TABLE_DATA?.[index]}
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </div>
      </>
    );
  };

  const renderImageIcon = (src, alt, width, height) => {
    return (
      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        style={{
          width: "105px",
          height: "105px",
          margin: "5px 38% -69px 38%",
        }}
      />
    );
  };

  const renderDiscoverRangeThreeWheeler = () => {
    const imageUrl = isPassenger
      ? (showNewVehicles ? imagesWEBP.passengerStickerImageIcon1 : imagesWEBP?.passengerStickerImageIcon)
      : imagesWEBP.cargoSticketImageIcom;
    return (
      <>
        {renderImageIcon(imageUrl, "cargo_icon_image", 105, 105)}
        <div className={styles?.DiscoverRangeMainContainer}>
          <div className={styles?.DiscoverRangeHeaderContainer}>
            <div className={styles.DiscoverRangeHeader}>
              {DISCOVER_RANGE_HEADER}
            </div>
            <div className={styles.DiscoverRangeSubHeaderText}>
              {DISCOVER_RANGE_SUBHEADER}
            </div>
          </div>
          <div className={styles?.DiscoverRangeContainer}>
            {DISCOVER_RANGE_LIST?.map(
              ({ image_url = "", icon_name = "" }, index) => (
                <div key={index} className={styles?.DiscoverRangeListContainer}>
                  <Image
                    className={styles.iconImages}
                    width={30}
                    height={30}
                    src={image_url}
                    alt={icon_name}
                  />
                  <div className={styles.DiscoverRangeListText}>
                    {icon_name}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        sendAnalytics(`v2_goods_${targetRef.current.id}_scroll`, {}, "en");
      }
    }, options);

    if (targetRef.current) observer.observe(targetRef.current);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (targetRef.current) observer.unobserve(targetRef.current);
    };
  }, [targetRef]);
  const vehicleData = isPassenger
    ? (showNewVehicles ? "newPassengerVehicles":"passengerVehicles")
    : "twoto3wGoodCommerical";
  return (
    <Box
      id="commercial"
      ref={targetRef}
      style={{ background: primary?.lightGrey }}
    >
      <Box style={{ marginBottom: "20px" }}>
        {renderWhyTurnoContent(
          WHY_TURNO_HEADER,
          WHY_TURNO_SUB_TEXT,
          WHY_TURNO_DATA
        )}
        {renderCommercialElectricTempoTable()}
        {renderDiscoverRangeThreeWheeler()}
        <div style={{ backgroundColor: "white" }}>
          <Box style={{ padding: "20px" }}>
            <Typography
              style={{
                fontSize: "24px",
                lineHeight: "38px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              {CHOOSE_ELECTRIC_AUTO_HEADER?.[0]}{" "}
              <span style={{ color: primary?.mainGreen }}>
                {CHOOSE_ELECTRIC_AUTO_HEADER?.[1]}
              </span>{" "}
              {CHOOSE_ELECTRIC_AUTO_HEADER?.[2]}
            </Typography>
          </Box>
          {BrandMiniVehicleData?.[vehicleData]?.map((details, index) => {
            return (
              <VehicleMiniCard
                details={details}
                id={index}
                key={index}
                ctaText={isHindi ? "ऑफर देखें" : "Get Offer"}
                isHindi={isHindi}
              />
            );
          })}
        </div>
        <ConnectWithUs
          popup={false}
          showForm={true}
          data={{
            heading: CONNECT_WITH_US_HEADER,
            subHeading: "",
            ctaInfo: CONNECT_WITH_US_CTA_INGO,
            image_url: isPassenger ? "smallVehiclePassgerImage" : "",
          }}
        />
        {renderTurnoReviewCard(REVIEW_CARDS_CONTENT, REVIEW_CARDS_HEADER)}

        {/* <LazyLoadImage
          style={{ width: "100%" }}
          src={imagesWEBP?.preSale2}
          visibleByDefault={true}
        />

        <LazyLoadImage
          style={{ width: "100%" }}
          src={imagesWEBP?.preSale3}
          visibleByDefault={true}
        />

        <LazyLoadImage
          style={{ width: "100%" }}
          src={imagesWEBP?.preSale3years}
          visibleByDefault={true}
        /> */}
      </Box>
    </Box>
  );
};

export const renderWhyTurnoContent = (
  WHY_TURNO_HEADER,
  WHY_TURNO_SUB_TEXT,
  WHY_TURNO_DATA
) => {
  return (
    <Box style={{ width: "100%", padding: "0px 20px" }}>
      <Typography
        style={{ fontSize: "24px", fontWeight: "600", textAlign: "center" }}
      >
        {WHY_TURNO_HEADER}
      </Typography>

      <Typography
        style={{
          fontSize: "14px",
          fontWeight: "500",
          textAlign: "center",
          marginTop: "10px",
        }}
      >
        {WHY_TURNO_SUB_TEXT}
      </Typography>

      <Grid
        container
        spacing={1}
        style={{ marginTop: "25px", alignItems: "center" }}
      >
        <Grid
          item
          xs={4}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {" "}
          <LazyLoadImage
            style={{ width: "90px", objectFit: "contain" }}
            src={imagesWEBP?.marketingTick}
            visibleByDefault={true}
            alt={"marketing tick"}
          />
        </Grid>
        <Grid item xs={8} style={{ width: "100%" }}>
          <Box>
            <Typography style={{ fontSize: "18px", fontWeight: "600" }}>
              {WHY_TURNO_DATA?.[0]?.header}
            </Typography>

            <Typography
              style={{
                fontSize: "14px",
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              {WHY_TURNO_DATA?.[0]?.content}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        style={{ marginTop: "25px", alignItems: "center" }}
      >
        <Grid
          item
          xs={4}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {" "}
          <LazyLoadImage
            style={{ width: "90px", objectFit: "contain" }}
            src={imagesWEBP?.marketingHeart}
            visibleByDefault={true}
            alt={"marketing heart"}
          />
        </Grid>
        <Grid item xs={8} style={{ width: "100%" }}>
          <Box>
            <Typography style={{ fontSize: "18px", fontWeight: "600" }}>
              {WHY_TURNO_DATA?.[1]?.header}
            </Typography>

            <Typography
              style={{
                fontSize: "14px",
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              {WHY_TURNO_DATA?.[1]?.content}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        style={{ marginTop: "25px", alignItems: "center" }}
      >
        <Grid
          item
          xs={4}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {" "}
          <LazyLoadImage
            style={{ width: "80px", objectFit: "contain", marginLeft: "-10px" }}
            src={imagesWEBP?.marketingDelivery}
            visibleByDefault={true}
            alt={"marketing secure"}
          />
        </Grid>
        <Grid item xs={8} style={{ width: "100%" }}>
          <Box>
            <Typography style={{ fontSize: "18px", fontWeight: "600" }}>
              {WHY_TURNO_DATA?.[2]?.header}
            </Typography>

            <Typography
              style={{
                fontSize: "14px",
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              {WHY_TURNO_DATA?.[2]?.content}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "25px", alignItems: "center" }}
      >
        <Grid
          item
          xs={4}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {" "}
          <LazyLoadImage
            style={{ width: "90px", objectFit: "contain" }}
            src={imagesWEBP?.markertingEmi}
            visibleByDefault={true}
            alt={"marketing secure"}
          />
        </Grid>
        <Grid item xs={8} style={{ width: "100%" }}>
          <Box>
            <Typography style={{ fontSize: "18px", fontWeight: "600" }}>
              {WHY_TURNO_DATA?.[3]?.header}
            </Typography>

            <Typography
              style={{
                fontSize: "14px",
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              {WHY_TURNO_DATA?.[3]?.content}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export const renderTurnoReviewCard = (
  REVIEW_CARDS_CONTENT = [],
  REVIEW_CARDS_HEADER = ""
) => {
  const renderReviewCard = (data) => {
    const {
      name = "",
      owner_of = "",
      review_point = "",
      review_descriptions = "",
      stars = 0,
      image_url = "",
    } = data;
    return (
      <div className={styles.turnoReviewCardContainer} style={{ padding: "0px 0px 0px 20px", backgroundColor: "#d3d3d3"}}>
        <div className={styles.headerContainer}>
          <div className={styles.userLogo}>
            <Image
              className={styles.userImage}
              width={40}
              height={40}
              src={image_url}
              alt="userLogo"
              style={{ borderRadius: "50%" }}
            />
          </div>
          <div className={styles.userInfo}>
            <div className={styles.userName}>{name}</div>
            {owner_of && (
              <div className={styles.userOwnerShip}>
                <span className={styles.ownerOfText}>{owner_of}</span>
              </div>
            )}
          </div>
        </div>
        <div className={styles.turnoReviewCardBody}>
          <div className={styles.starsPars}>
            {Array.from({ length: 5 }, (_, i) =>
              i < stars ? (
                <span style={{ fontSize: "14px" }} key={i}>
                  &#11088;
                </span>
              ) : (
                <span style={{ fontSize: "14px" }} key={i}>
                  &#9734;
                </span>
              )
            )}
            <span className={styles.reviewPointText}>{review_point}</span>
          </div>
          <div className={styles.ReviewSummary}>{review_descriptions}</div>
        </div>
      </div>
    );
  };
  return (
    <>
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          paddingTop: "10px",
          paddingBottom: "20px",
          fontSize: "22px",
          fontWeight: "800",
          color: "black",
        }}
      >
        {REVIEW_CARDS_HEADER}
      </Box>
      <Box>
        <Swiper
          slidesPerView={1.2}
          spaceBetween={0}
          centeredSlides={false}
          pagination={false}
          loop={true}
          modules={[Pagination]}
          className="swiper-turno-india"
          onSlideChange={() => {
            sendAnalytics("v2_review_slide", {}, "en");
          }}
        >
          {REVIEW_CARDS_CONTENT?.map((data, index) => {
            return (
              <SwiperSlide key={index}>
                <Box style={{ margin: "10px" }}>{renderReviewCard(data)}</Box>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Box>
    </>
  );
};

export const MemoizedWhyTurno = React.memo(WhyTurno);
